import React, { ReactNode } from 'react';
import BackButton from 'common/components/Back';
import { ValueType } from 'common/types';
import { Props as BackButtonType } from 'common/components/Back/Back';
import s from './LayoutHeader.module.scss';
import { HEADER_ITEMS } from 'common/layouts/Layout/LayoutHeader/items';
import { HEADER_VARIANTS } from 'common/layouts/Layout/LayoutHeader/modes';
import { SurfaceColor } from 'common/components/utils.ts';
import { getPathToIcon } from 'src/common/utils/utilities';
import { Divider } from '@tapsioss/react-components/Divider';

export type LayoutHeaderProps = {
  items?: {
    start?: (ValueType<typeof HEADER_ITEMS> | ReactNode)[];
    end?: (ValueType<typeof HEADER_ITEMS> | ReactNode)[];
  };
  variant?: ValueType<typeof HEADER_VARIANTS>;
  title?: string;
  bgColor?: SurfaceColor;
  backButtonProps?: BackButtonType;
  className?: string;
  scrolled?: boolean;
  children?: ReactNode;
};

const LayoutHeader = ({
  items = { start: ['back'] },
  variant = HEADER_VARIANTS.FLOATING,
  title = '',
  backButtonProps,
  className = '',
  scrolled,
  bgColor,
  children,
}: LayoutHeaderProps) => {
  return (
    <header className={`${s.layoutHeader} ${s[variant]}`}>
      <div className={(className || '').concat(` bg-${bgColor} `, s.innerDiv)}>
        <div className={s.headerStart}>
          {items?.start?.map((item, idx) => {
            switch (item) {
              case HEADER_ITEMS.BACK_BUTTON:
                return (
                  <BackButton
                    hasShadow={variant === HEADER_VARIANTS.FLOATING}
                    hasBackground={variant === HEADER_VARIANTS.FLOATING}
                    {...backButtonProps}
                    key="layout-header-start-button"
                  />
                );
              case HEADER_ITEMS.TAPSI_LOGO:
                return (
                  <img
                    src={getPathToIcon('tapsi-logo')}
                    height={20}
                    width={20}
                    alt="tapsi"
                    key="layout-header-start-tapsi-logo"
                  />
                );
              default:
                return <React.Fragment key={`layout-header-start-custom-${idx}`}>{item}</React.Fragment>;
            }
          })}
          <h1>{title}</h1>
        </div>
        {children}
        <div className={s.headerEnd}>
          {items?.end?.map((item) => {
            if (item == HEADER_ITEMS.SIDEBAR) return <>|||</>;
            else return <React.Fragment key={`layout-header-end-custom-${item?.toString()}`}>{item}</React.Fragment>;
          })}
        </div>
      </div>
      {variant === HEADER_VARIANTS.FIXED && scrolled && (
        <div className={s.scrollDivider}>
          <Divider />
        </div>
      )}
    </header>
  );
};

export default LayoutHeader;
